export function requireAuth(to, from, next) {
  if (!isAuthenticated()) {
    next({
      path: "/login",
      query: { redirect: to.fullPath },
      replace: true
    });
  }

  next();
}

export function isAuthenticated() {
  return window.isAuthenticated;
}
